import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasAnyAdminAccess } from './adminAccess'

// The hub exposes only links; each destination retains its own route guard and
// backend authorization. Users without any admin capability return to dashboard.
export default function AdminHubRoute() {
  const { user, isLoading } = useAuth()

  if (isLoading) return null
  if (hasAnyAdminAccess(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
